import React, { FormEvent, useEffect, useState } from 'react'
import TextField from '@material-ui/core/TextField'
import PasswordField from '@views/shared/PasswordField'
import logo from '@assets/Logo.png'
import Button from '@material-ui/core/Button'
import { Box, CircularProgress } from '@material-ui/core'
import { useDispatch, useSelector } from 'react-redux'
import { expireOtp, login, resetOtp, selectIsLoading, selectLoginFlow, verifyOtp } from './state/loginSlice'
import { useSnackbar } from 'notistack'
import { useHistory } from 'react-router'
import { Link } from 'react-router-dom'
import OtpVerificationCard from './OtpVerificationCard'

const LoginView: React.FC = () => {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const { enqueueSnackbar } = useSnackbar()
  const history = useHistory()
  const dispatch = useDispatch()
  const { isLoading, isLogged, isFailed, message } = useSelector(selectIsLoading)
  const { step, challengeId, email, expiresAt, resendAt } = useSelector(selectLoginFlow)
  const otpRequired = step === 'OTP_REQUIRED' || step === 'OTP_EXPIRED' || step === 'VERIFYING_OTP'

  const requestOtp = (event?: FormEvent) => {
    event?.preventDefault()
    dispatch(login({ username, password }))
  }

  const changeCredentials = () => {
    dispatch(resetOtp())
  }

  const handleExpiredOtp = () => {
    dispatch(expireOtp())
  }

  useEffect(() => {
    if (isLogged) {
      enqueueSnackbar('Iniciado correctamente!', { variant: 'success' })
      history.push('/')
    } else if (isFailed && message) {
      enqueueSnackbar(`Error iniciando sesión: ${message}`, {
        variant: 'error'
      })
    }
  }, [enqueueSnackbar, history, isFailed, isLogged, message])

  useEffect(() => {
    const expired = sessionStorage.getItem('cocap:session-expired')
    if (expired) {
      sessionStorage.removeItem('cocap:session-expired')
      enqueueSnackbar('Tu sesión expiró. Inicia sesión nuevamente.', {
        variant: 'warning'
      })
    }
  }, [enqueueSnackbar])

  return (
    <div className="center_view">
      <img src={logo} alt="CO Capitalizaciones" style={{ height: '7em' }} />
      {otpRequired ? (
        <OtpVerificationCard
          key={challengeId}
          email={email}
          expiresAt={expiresAt}
          resendAt={resendAt}
          loading={isLoading}
          expired={step === 'OTP_EXPIRED'}
          onVerify={code => dispatch(verifyOtp({ challengeId, otp: code }))}
          onResend={() => requestOtp()}
          onChangeCredentials={changeCredentials}
          onExpired={handleExpiredOtp}
        />
      ) : (
        <form onSubmit={requestOtp} style={{ width: 'min(100%, 460px)' }}>
          <TextField
            fullWidth
            variant="outlined"
            id="email"
            label="email"
            value={username}
            onChange={event => setUsername(event.target.value.toLowerCase())}
            margin="normal"
            disabled={isLoading || isLogged}
          />
          <PasswordField
            fullWidth
            variant="outlined"
            id="pass"
            label="contraseña"
            value={password}
            onChange={event => setPassword(event.target.value)}
            margin="normal"
            disabled={isLoading || isLogged}
          />
          <Box textAlign="center" width="100%" marginTop="8px">
            <Link to="/password-recovery" style={{ color: '#e65f00', fontWeight: 600 }}>
              ¿Olvidaste tu contraseña?
            </Link>
          </Box>
          <Box display="flex" justifyContent="center" margin="20px">
            {isLoading || isLogged ? (
              <CircularProgress />
            ) : (
              <Button type="submit" variant="contained" color="primary">
                Iniciar Sesion
              </Button>
            )}
          </Box>
        </form>
      )}
    </div>
  )
}

export default LoginView
